<template>
    <div id="shipment-builder-module" :class="{ empty: !moduleData }">
        <div
            class="module"
            v-if="moduleData"
            :class="moduleData.Background + ' ' + moduleData.Spacing"
            :id="moduleData.AnchorID"
        >
            <ShipmentBuilder :settings="currentSettings" />
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ShipmentBuilder from "../wineclub/shipmentBuilder/ShipmentBuilder";
import Loading from "../Loading";

export default {
    name: "shipment-builder-module",
    components: {
        ShipmentBuilder,
        Loading,
    },
    props: {
        component: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters(["getModuleData", "getConfigStep"]),
        currentSettings() {
            return {
                ClubData: this.moduleData.ClubData,
                MemberData: this.moduleData.MemberData,
                // This takes out the 'Flexi' tier since it's `AnuallyBottles` value is 0
                // this should really be controled via a flag on the server just passing the tiers we want to use
                // since tecnically we could still edit requests with the 'Flexi' ID and it would be valid
                Memberships: this.moduleData.Memberships.filter(m => m.AnnuallyBottles > 0)
            };
        },
        moduleData() {
            return this.getModuleData(this.component.ID);
        },
    },
    methods: {
        ...mapActions(["fetchModuleData"]),
    },
    created() {
        // this.fetchModuleData(this.component.ID);
    },
};
</script>
